module.exports = __webpack_public_path__ + "static/img/home-logo-onetype.93452ae0.jpg";